import { render, staticRenderFns } from "./mjl.vue?vue&type=template&id=08d16dce"
import script from "./mjl.vue?vue&type=script&lang=js"
export * from "./mjl.vue?vue&type=script&lang=js"
import style0 from "./mjl.vue?vue&type=style&index=0&id=08d16dce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports